/**
 * How an endorsement changes the premium.
 */
export enum EndorsementPremiumChange {
  ADDITION = 'Additional premium',
  RETURN = 'Return premium',
  NONE = 'Nil change to premium',
}
